import { Pipe, PipeTransform } from '@angular/core';
import { IConversationComponentData } from '../conversation-data.component';

@Pipe({
  name: 'hasContent',
  standalone: true,
})
export class HasContentPipe implements PipeTransform {
  transform({ conversationDetails, scorecard }: IConversationComponentData): boolean {
    return (
      Boolean(conversationDetails?.tags?.data?.length) ||
      Boolean(conversationDetails?.contactDetails?.data) ||
      Boolean(conversationDetails?.appointmentDetails?.data) ||
      Boolean(conversationDetails?.leasingPreferences?.data) ||
      Boolean(conversationDetails?.campaignDetails?.data) ||
      Boolean(conversationDetails?.conversationDetails?.data) ||
      Boolean(scorecard?.scorecardPreview?.data)
    );
  }
}
